import React from 'react';
import ChannelForm from '../Create/ChannelForm';
import { useParams } from 'react-router-dom';

const ChannelDetailPage = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <ChannelForm idChannel={id}/>
  );
};

export default ChannelDetailPage;